<div
    class="table-container"
    [ngClass]="{ 'mat-elevation-z2': isCard }"
    [style.height]="containerHeight"
>
    <ng-container *ngIf="allowFiltering">
        <div class="table-header">
            <mat-form-field appearance="fill">
                <mat-label>Search</mat-label>
                <input matInput [(ngModel)]="searchText" (keyup)="applyFilter()" />
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <span class="results-counter"
                >{{ this.tableDataSource.filteredData.length }} results
                <button
                    mat-icon-button
                    *ngIf="allowDownloading"
                    matTooltip="Export to CSV"
                    (click)="export()"
                >
                    <mat-icon>file_download</mat-icon>
                </button>
            </span>
        </div>
        <ng-content select="[actions]"></ng-content>
        <mat-divider></mat-divider>
    </ng-container>

    <table
        mat-table
        matSort
        aria-label="data table"
        [dataSource]="tableDataSource"
        [matSortDisableClear]="disableSortClear"
        [class.clickable]="allowRowClick"
    >
        <ng-container *ngIf="allowMultiSelect" matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    color="primary"
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                >
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox
                    color="primary"
                    (click)="$event.stopPropagation()"
                    (change)="rowSelectionToggle(row)"
                    [checked]="selection.isSelected(row)"
                >
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container *ngFor="let column of columns" [matColumnDef]="column.key">
            <ng-container *ngIf="column.isSortable; else notSortable">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    [mat-sort-header]="column.key"
                    [arrowPosition]="'after'"
                    [class]="column.alignment"
                    [style]="{
                        'max-width': column.maxWidth ? column.maxWidth + 'px' : '100%'
                    }"
                    [style.width.px]="column.fixedWidth"
                >
                    {{ column.name }}
                </th>
            </ng-container>

            <ng-template #notSortable>
                <th mat-header-cell *matHeaderCellDef [class]="column.alignment">
                    {{ column.name }}
                </th>
            </ng-template>

            <td
                mat-cell
                *matCellDef="let element"
                [class]="column.alignment"
                [ngSwitch]="element[column.key].type"
                [style]="{ 'max-width': column.maxWidth ? column.maxWidth + 'px' : '100%' }"
                [style.width.px]="column.fixedWidth"
            >
                <ng-container *ngSwitchCase="tableDataTypes.TEXT">
                    {{ element[column.key].value }}
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.TEXT_ASYNC">
                    <div *ngIf="element[column.key].value | async as text; else loading">
                        <span *ngIf="text.length > 0">{{ text }}</span>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.MULTILINE">
                    <div>{{ element[column.key].value }}</div>
                    <div>{{ element[column.key].metadata.secondLine }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.SUPERSCRIPT">
                    <div class="subtle">{{ element[column.key].metadata.superscript }}</div>
                    <div>{{ element[column.key].value }}</div>
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.STATUS">
                    <app-status-indicator [type]="element[column.key].metadata.type">
                        <span content>{{ element[column.key].value }}</span>
                    </app-status-indicator>
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.IMAGE">
                    <div *ngIf="element[column.key].value | async as image; else loading">
                        <ng-container *ngIf="image.source; else icon">
                            <div class="image-container">
                                <img class="image" [src]="image.source | safeUrl" alt="image" />
                            </div>
                        </ng-container>
                        <ng-template #icon>
                            <div class="icon-container">
                                <mat-icon class="icon">{{ image.defaultIcon }}</mat-icon>
                            </div>
                        </ng-template>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.EVENT">
                    <div class="inline">
                        <app-category-indicator
                            [color]="element[column.key].metadata.color"
                        ></app-category-indicator>
                        {{ element[column.key].value }}
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.LIST">
                    <ul class="list">
                        <li *ngFor="let item of element[column.key].value">{{ item }}</li>
                    </ul>
                </ng-container>
                <ng-container *ngSwitchCase="tableDataTypes.TEMPLATE">
                    <ng-container
                        [ngTemplateOutlet]="element[column.key].metadata.templateRef"
                        [ngTemplateOutletContext]="{ data: element[column.key].value }"
                    ></ng-container>
                </ng-container>
                <ng-template #loading>
                    <mat-spinner diameter="20" strokeWidth="2"></mat-spinner>
                </ng-template>
            </td>
        </ng-container>

        <ng-container *ngIf="showRowActions">
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef [style.width]="actionsWidth"></th>
                <td
                    mat-cell
                    *matCellDef="let element"
                    class="actions-column"
                    [ngClass]="{ visible: element.actionsVisible }"
                    [style.width]="actionsWidth"
                >
                    <div>
                        @if(element.disableActions !== null && !element.disableActions) {
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="rowsMenu"
                            [matMenuTriggerData]="{ element: element }"
                            (menuOpened)="onContextMenuToggle(element, true)"
                            (menuClosed)="onContextMenuToggle(element, false)"
                        >
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        }
                    </div>
                </td>
            </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: !useTablePagination"></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="onRowClick(row, $event)"
        ></tr>

        <tr *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="columns.length">
                <ng-content select="[emptyState]"></ng-content>
            </td>
        </tr>
    </table>

    <ng-content select="[loader]"></ng-content>

    <mat-paginator
        *ngIf="useTablePagination"
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
    >
    </mat-paginator>
</div>

<mat-menu #rowsMenu="matMenu">
    <div class="context-menu">
        <ng-template matMenuContent let-element="element">
            <button
                mat-menu-item
                *ngFor="let action of actions"
                [enableAdminOnly]="action.enableAdminOnly"
                [disabled]="element.disabledActions?.includes(action.key)"
                (click)="execute(action, element.element)"
            >
                {{ action.text }}
            </button>
        </ng-template>
    </div>
</mat-menu>
